export default {"src":"/_next/static/media/train-error-icon.10afec8f.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};